import { render, staticRenderFns } from "./StudentsBlacklist.vue?vue&type=template&id=ad74f0e8&scoped=true&"
import script from "./StudentsBlacklist.vue?vue&type=script&lang=js&"
export * from "./StudentsBlacklist.vue?vue&type=script&lang=js&"
import style0 from "./StudentsBlacklist.vue?vue&type=style&index=0&id=ad74f0e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad74f0e8",
  null
  
)

export default component.exports